import React from "react";
import { Icon } from "@fluentui/react";

const FileChip: React.FC<{ file: File; onRemove: () => void }> = ({ file, onRemove }) => {
    return (
        <div
            style={{
                display: "inline-flex",
                alignItems: "center",
                padding: "4px 8px",
                marginRight: "6px",
                backgroundColor: "#e0f0ff",
                borderRadius: "20px",
                fontSize: "14px",
            }}
        >
            <Icon iconName="Attach" style={{ marginRight: 4, fontSize: "16px", color: "#0078D7" }} />
            <span>{file.name}</span>
            <button
                onClick={onRemove}
                style={{
                    marginLeft: "6px",
                    border: "none",
                    background: "transparent",
                    cursor: "pointer",
                    color: "#0078D7",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    padding: 0,
                }}
                title="Remove file"
            >
                <Icon iconName="Cancel" style={{ fontSize: 14, color: "#0078D7" }} />
            </button>
        </div>
    );
};


export default FileChip;